import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const ChartWrapper = styled.div`
  background-color: ${colors.chartBackground};
  width: 400px;
  border: 1px solid ${colors.greyStroke};
  border-radius: 4px;
  padding: 16px;
`

export const ChartHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const ChartTitle = styled.p`
  color: ${colors.mainText};
`

export const ChartDays = styled.span`
  color: ${colors.greyTextWhiteBg};
`
export const StyledButton = styled.button`
  background-color: transparent;
`

export const StyledArea = styled.div`
  & svg {
    width: 100%;
    height: 100%;
  }
`
